module.exports = __webpack_public_path__ + "img/repair_card3.2e6d1dcf.png";